import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import { useParams, useNavigate } from "react-router-dom";

const UsuariosForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: -1,
        nombre: "",
        apellido: "",
        correo_electronico: "",
        perfil: 1,
        estado: 1,
        telefono: "",
        direccion: "",
        cant_visitas: 0
    });
    const [perfiles, setPerfiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true); // Para manejar el estado de carga

    useEffect(() => {
        async function fetchData() {
            try {
                // Obtener los perfiles
                const perfilesResponse = await axiosInstance.get("/params/perfiles");
                setPerfiles(perfilesResponse.data.perfiles);

                // Si el id no es -1, cargar los datos del usuario
                if (id != -1 && id != 'nuevo') {
                    const usuarioResponse = await axiosInstance.get(`/usuario/${id}`);
                    setFormData((prevState) => ({
                        ...prevState,  // Mantiene los valores anteriores
                        id: usuarioResponse.data.data.id,
                        nombre: usuarioResponse.data.data.nombre,
                        apellido: usuarioResponse.data.data.apellido,
                        correo_electronico: usuarioResponse.data.data.correo_electronico,
                        perfil: usuarioResponse.data.data.perfil,
                        estado: usuarioResponse.data.data.estado === 1 ? "activo" : "inactivo",
                        telefono: usuarioResponse.data.data.telefono,
                        direccion: usuarioResponse.data.data.direccion,
                        cant_visitas: usuarioResponse.data.data.cant_visitas_mes
                    }));
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, [id]);

    const estados = ["activo", "inactivo"];

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,  // Solo actualiza el campo que cambió
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const usuarioData = {
                ...formData,
                estado: formData.estado === "activo" ? 1 : 0, // Convertir el estado a 1 o 0
            };

            let response = await axiosInstance.post(`/usuario/guardar`, usuarioData);

            console.log("Usuario guardado:", response.data);
            navigate("/usuarios"); // Redirigir a la lista de usuarios
        } catch (error) {
            console.error("Error al guardar usuario:", error);
        }
    };

    if (isLoading) {
        return <div>Cargando...</div>; // Indicador de carga
    }

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-header">Registro de Usuario</div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <input type="hidden" name="id" value={formData.id} />
                        {/* Fila 1 */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Nombre</label>
                                <input
                                    type="text"
                                    name="nombre"
                                    className="form-control"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Apellido</label>
                                <input
                                    type="text"
                                    name="apellido"
                                    className="form-control"
                                    value={formData.apellido}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Correo Electrónico</label>
                                <input
                                    type="email"
                                    name="correo_electronico"
                                    className="form-control"
                                    value={formData.correo_electronico}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        {/* Fila 2 */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Perfil</label>
                                <select
                                    name="perfil"
                                    className="form-control"
                                    value={formData.perfil}
                                    onChange={handleChange}
                                >
                                    {perfiles.map((perfil) => (
                                        <option key={perfil.id} value={perfil.id}>
                                            {perfil.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Estado</label>
                                <select
                                    name="estado"
                                    className="form-control"
                                    value={formData.estado}
                                    onChange={handleChange}
                                >
                                    {estados.map((estado) => (
                                        <option key={estado} value={estado}>
                                            {estado.charAt(0).toUpperCase() + estado.slice(1)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Teléfono</label>
                                <input
                                    type="text"
                                    name="telefono"
                                    className="form-control"
                                    value={formData.telefono}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* Fila 3 */}
                        <div className="row mb-3">
                            <div className="col-md-8">
                                <label className="form-label">Dirección</label>
                                <textarea
                                    name="direccion"
                                    className="form-control"
                                    value={formData.direccion}
                                    onChange={handleChange}
                                ></textarea>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-8">
                                <label className="form-label">Cantidad Visita Mes</label>
                                <input
                                    type="number"
                                    name="cant_visitas"
                                    className="form-control"
                                    value={formData.cant_visitas}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <button type="submit" className="btn btn-primary">
                            {id === "-1" ? "Registrar" : "Actualizar"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UsuariosForm;
